/**
 * alertSounds — the ping sounds a team member can be given (Settings → Alerts → "Alert colour and sound per team member").
 *
 * ONE list, two readers: the classic ConfigurePracticePulse.vue (`alertSounds` computed) and the Practice Ops
 * Settings panel. The stored value is the whole `{ name, url, type }` object under `settings.providerSettings[employeeID].sound`
 * (that is what the page's ping watcher downloads and plays), so the shape and the bucket URLs here are exactly the
 * classic's — change a sound in this file and both pages follow.
 *
 * ⚠️ Keep this file import-free. The node-tests execute this exact file.
 */

const FILES = [
  ['call-to-attention', 'call-to-attention-123107.mp3'],
  ['elevator-ding', 'elevator-ding.mp3'],
  ['error', 'error-2-126514.mp3'],
  ['success', 'short-success-sound-glockenspiel-treasure-video-game-6346.mp3'],
  ['wrong-answer', 'wrong-answer-129254.mp3'],
  ['simple-notification', 'simple-notification-152054.mp3'],
  ['sound-alert', 'sound-alert-device-174892.mp3'],
  ['beep-beep', 'beep-beep-6151.mp3'],
  ['bell', 'bell-123742.mp3'],
  ['notification', 'notification-4-126507.mp3'],
];

/** @param {boolean} isDev  the dev bucket when true (the classic page's `isDev`) */
export function alertSoundList(isDev) {
  const prefix = isDev ? 'https://teamio-frontend.s3.us-east-1.amazonaws.com' : 'https://teamio-frontend-prod.s3.us-east-1.amazonaws.com';
  return FILES.map(([name, file]) => ({ name, url: `${prefix}/sounds/${file}`, type: 'audio/mp3' }));
}
